<script setup lang="ts">
import HookingFacade from '~/modules/WidgetsAndHooks/runtime/HookingFacade'
import type { HookWidgetInterface } from '~/types/widgets/widgetTypes'

const { widget } = defineProps<{ widget: HookWidgetInterface }>()
const widgetComponentInstance = HookingFacade.findWidgetComponentByType(widget.type)
</script>

<template>
  <component :is="widgetComponentInstance" v-bind="widget.properties" />
</template>
